import React from 'react'
import SettingsLeadsForm from '../components/setting/settingsLeadsForm'

const SettingsLeads = () => {
    return (
        <SettingsLeadsForm />

    )
}

export default SettingsLeads